class ThemeCart {
  constructor() {
    this.addToCartForms = document.querySelectorAll('form[action*="/cart/add"], form[data-product-form]');
    this.cartCountBubbles = document.querySelectorAll('[data-cart-count-bubble]');
    this.cartCount = document.querySelector('[data-cart-count]');
    
    this.init();
  }
  
  init() {
    this.addToCartForms.forEach(form => {
      form.addEventListener('submit', this.handleAddToCart.bind(this));
    });
    
    // Initialize cart drawer functionality
    this.initCartDrawer();
    
    // Attach listeners to existing cart items on page load
    setTimeout(() => {
      this.attachCartItemListeners();
    }, 100);
  }
  
  initCartDrawer() {
    // Cart toggle button
    const cartToggle = document.querySelector('.header__cart-toggle');
    const cartDrawer = document.getElementById('cart-drawer');
    const cartClose = cartDrawer ? cartDrawer.querySelector('.cart-drawer__close') : null;
    const cartOverlay = cartDrawer ? cartDrawer.querySelector('.cart-drawer__overlay') : null;
    
    if (cartToggle && cartDrawer) {
      cartToggle.addEventListener('click', (e) => {
        e.preventDefault();
        this.openCartDrawer();
      });
    }
    
    if (cartClose) {
      cartClose.addEventListener('click', () => {
        this.closeCartDrawer();
      });
    }
    
    if (cartOverlay) {
      cartOverlay.addEventListener('click', () => {
        this.closeCartDrawer();
      });
    }
  }
  
  handleAddToCart(event) {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);
    const submitButton = form.querySelector('[type="submit"]');
    
    // Store original text
    const originalText = submitButton ? submitButton.textContent : 'Aggiungi al carrello';
    
    // Disable button and show loading state
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Aggiungendo...';
    }
    
    // Ensure we have the cart add URL
    const cartAddUrl = window.routes?.cart_add_url || '/cart/add.js';
    
    fetch(cartAddUrl, {
      method: 'POST',
      body: formData
    })
    .then(response => {
      // Check if response is ok before parsing
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      // Check for various error conditions
      if (data.status === 422 || data.status === 'bad_request') {
        alert(data.description || data.message || 'Errore nell\'aggiunta al carrello');
      } else {
        // Success - update cart
        this.updateCartCount();
        this.openCartDrawer();
        this.updateCartDrawer();
      }
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      // Try to update cart count anyway in case the item was added
      this.updateCartCount();
      // Check if cart drawer should open
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          if (cart.item_count > 0) {
            this.openCartDrawer();
            this.updateCartDrawer();
          } else {
            alert('Si è verificato un errore. Riprova.');
          }
        });
    })
    .finally(() => {
      // Re-enable button
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalText;
      }
    });
  }
  
  updateCartCount() {
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      this.cartCountBubbles.forEach(bubble => {
        bubble.textContent = cart.item_count;
      });
      
      if (this.cartCount) {
        this.cartCount.setAttribute('data-cart-count', cart.item_count);
      }
    });
  }
  
  updateCartDrawer() {
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartDrawerBody = document.querySelector('.cart-drawer__body');
      let cartDrawerFooter = document.querySelector('.cart-drawer__footer');
      
      if (!cartDrawerBody) return;
      
      if (cart.item_count === 0) {
        // Empty cart
        cartDrawerBody.innerHTML = `
          <div class="cart-drawer__empty">
            <p>Il tuo carrello è vuoto</p>
            <a href="/collections/all" class="btn btn--secondary">
              Continua lo shopping
            </a>
          </div>
        `;
        if (cartDrawerFooter) {
          cartDrawerFooter.style.display = 'none';
        }
      } else {
        // Build cart items HTML
        let cartItemsHTML = '<div class="cart-drawer__items">';
        
        cart.items.forEach(item => {
          const variantTitle = item.product_has_only_default_variant ? '' : `<p class="cart-item__variant">${item.variant_title}</p>`;
          
          cartItemsHTML += `
            <div class="cart-item" data-line-item-key="${item.key}">
              <div class="cart-item__image">
                <img src="${item.featured_image.url}" alt="${item.featured_image.alt || ''}" loading="lazy">
              </div>
              
              <div class="cart-item__details">
                <h3 class="cart-item__title">
                  <a href="${item.url}">${item.product_title}</a>
                </h3>
                ${variantTitle}
                <div class="cart-item__price">
                  ${this.formatMoney(item.final_line_price)}
                </div>
                
                <div class="cart-item__quantity">
                  <button class="cart-item__quantity-btn" data-action="decrease" data-line-key="${item.key}">-</button>
                  <input type="number" 
                         class="cart-item__quantity-input"
                         value="${item.quantity}"
                         min="0"
                         data-quantity
                         data-line-key="${item.key}">
                  <button class="cart-item__quantity-btn" data-action="increase" data-line-key="${item.key}">+</button>
                </div>
              </div>
              
              <button class="cart-item__remove" data-action="remove" data-line-key="${item.key}" aria-label="Rimuovi">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="2"/>
                </svg>
              </button>
            </div>
          `;
        });
        
        cartItemsHTML += '</div>';
        
        // Add free shipping bar if enabled
        if (window.Shopify && window.Shopify.theme && window.Shopify.theme.settings && window.Shopify.theme.settings.free_shipping_bar) {
          const threshold = parseInt(window.Shopify.theme.settings.free_shipping_threshold || 100) * 100;
          const progress = (cart.total_price / threshold) * 100;
          const remaining = threshold - cart.total_price;
          
          cartItemsHTML += `
            <div class="free-shipping-bar">
              ${cart.total_price >= threshold ? 
                '<p class="free-shipping-bar__message">✓ Hai diritto alla spedizione gratuita!</p>' :
                `<p class="free-shipping-bar__message">Mancano ${this.formatMoney(remaining)} per la spedizione gratuita</p>
                <div class="free-shipping-bar__progress">
                  <div class="free-shipping-bar__fill" style="width: ${Math.min(progress, 100)}%"></div>
                </div>`
              }
            </div>
          `;
        }
        
        cartDrawerBody.innerHTML = cartItemsHTML;
        
        // Update footer
        if (!cartDrawerFooter) {
          // Create footer if it doesn't exist
          const cartContent = document.querySelector('.cart-drawer__content');
          if (cartContent) {
            const footerHTML = `
              <div class="cart-drawer__footer">
                <div class="cart-drawer__subtotal">
                  <span>Subtotale</span>
                  <span class="cart-drawer__subtotal-price">${this.formatMoney(cart.total_price)}</span>
                </div>
                
                <p class="cart-drawer__tax-note">
                  Tasse e spedizione calcolate al checkout
                </p>
                
                <div class="cart-drawer__buttons">
                  <a href="/cart" class="btn btn--secondary btn--full">
                    Visualizza carrello
                  </a>
                  <form action="/cart" method="post">
                    <button type="submit" name="checkout" class="btn btn--primary btn--full">
                      Procedi al checkout
                    </button>
                  </form>
                </div>
              </div>
            `;
            cartContent.insertAdjacentHTML('beforeend', footerHTML);
            // Re-select the footer after creating it
            cartDrawerFooter = document.querySelector('.cart-drawer__footer');
          }
        }
        
        if (cartDrawerFooter) {
          cartDrawerFooter.style.display = 'block';
          const subtotalElement = cartDrawerFooter.querySelector('.cart-drawer__subtotal-price');
          if (subtotalElement) {
            subtotalElement.textContent = this.formatMoney(cart.total_price);
          }
        }
        
        // Re-attach event listeners
        this.attachCartItemListeners();
      }
    })
    .catch(error => {
      console.error('Error updating cart drawer:', error);
    });
  }
  
  formatMoney(cents) {
    const money = (cents / 100).toFixed(2);
    return `€${money}`;
  }
  
  attachCartItemListeners() {
    const cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer) return;
    
    console.log('Attaching cart item listeners...');
    
    // Quantity buttons
    cartDrawer.querySelectorAll('.cart-item__quantity-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const action = e.currentTarget.dataset.action;
        const lineKey = e.currentTarget.dataset.lineKey;
        const input = cartDrawer.querySelector(`.cart-item__quantity-input[data-line-key="${lineKey}"]`);
        let quantity = parseInt(input.value);
        
        console.log('Quantity button clicked:', { action, lineKey, currentQuantity: quantity });
        
        if (action === 'increase') {
          quantity++;
        } else if (action === 'decrease' && quantity > 0) {
          quantity--;
        }
        
        this.updateCartItem(lineKey, quantity);
      });
    });
    
    // Remove buttons
    const removeButtons = cartDrawer.querySelectorAll('.cart-item__remove');
    console.log('Remove buttons found:', removeButtons.length);
    
    removeButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const lineKey = e.currentTarget.dataset.lineKey;
        console.log('Remove button clicked, lineKey:', lineKey);
        this.updateCartItem(lineKey, 0);
      });
    });
    
    // Quantity inputs
    cartDrawer.querySelectorAll('.cart-item__quantity-input').forEach(input => {
      input.addEventListener('change', (e) => {
        const lineKey = e.currentTarget.dataset.lineKey;
        const quantity = parseInt(e.currentTarget.value) || 0;
        console.log('Quantity input changed:', { lineKey, quantity });
        this.updateCartItem(lineKey, quantity);
      });
    });
  }
  
  updateCartItem(lineKey, quantity) {
    console.log('Updating cart item:', { lineKey, quantity });
    
    // Show loading state
    const cartItem = document.querySelector(`.cart-item[data-line-item-key="${lineKey}"]`);
    if (cartItem) {
      cartItem.style.opacity = '0.5';
      cartItem.style.pointerEvents = 'none';
    }
    
    const data = {
      updates: {
        [lineKey]: quantity
      }
    };
    
    console.log('Sending update request:', data);
    
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      console.log('Update response status:', response.status);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(cart => {
      console.log('Cart updated successfully:', cart);
      this.updateCartCount();
      this.updateCartDrawer();
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      // Reset loading state
      if (cartItem) {
        cartItem.style.opacity = '1';
        cartItem.style.pointerEvents = 'auto';
      }
      alert('Errore durante l\'aggiornamento del carrello. Riprova.');
    });
  }
  
  openCartDrawer() {
    const cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      // Update cart drawer content when opening
      this.updateCartDrawer();
    }
  }
  
  closeCartDrawer() {
    const cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }
}

class ProductVariants {
  constructor() {
    this.variantSelectors = document.querySelectorAll('[name="options"]');
    this.productForm = document.querySelector('form[action*="/cart/add"]');
    
    if (this.variantSelectors.length > 0) {
      this.init();
    }
  }
  
  init() {
    this.variantSelectors.forEach(selector => {
      selector.addEventListener('change', this.handleVariantChange.bind(this));
    });
  }
  
  handleVariantChange() {
    const selectedOptions = Array.from(this.variantSelectors).map(selector => selector.value);
    // Logic to find matching variant and update product info
  }
}

class ThemeSearch {
  constructor() {
    this.searchToggle = document.querySelector('.header__search-toggle');
    this.searchDrawer = document.querySelector('.header__search-drawer');
    this.searchInput = document.querySelector('.search-form__input');
    
    console.log('ThemeSearch elements found:', {
      searchToggle: !!this.searchToggle,
      searchDrawer: !!this.searchDrawer,
      searchInput: !!this.searchInput
    });
    
    if (this.searchToggle && this.searchDrawer) {
      this.init();
    }
  }
  
  init() {
    this.searchToggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggleSearch();
    });
    
    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.searchDrawer.classList.contains('is-open')) {
        this.closeSearch();
      }
    });
    
    // Close on click outside
    document.addEventListener('click', (e) => {
      if (!this.searchDrawer.contains(e.target) && !this.searchToggle.contains(e.target)) {
        this.closeSearch();
      }
    });
  }
  
  toggleSearch() {
    console.log('Toggling search drawer');
    this.searchDrawer.classList.toggle('is-open');
    
    if (this.searchDrawer.classList.contains('is-open')) {
      // Calculate total header height (announcement bar + header)
      const header = document.querySelector('.header');
      const announcementBar = document.querySelector('.announcement-bar');
      let totalHeight = 0;
      
      if (announcementBar) {
        totalHeight += announcementBar.offsetHeight;
      }
      if (header) {
        totalHeight += header.offsetHeight;
      }
      
      // Set the top position dynamically
      this.searchDrawer.style.setProperty('--header-height', totalHeight + 'px');
      this.searchDrawer.style.top = totalHeight + 'px';
      
      // Focus input after animation
      setTimeout(() => {
        if (this.searchInput) {
          this.searchInput.focus();
        }
      }, 300);
    }
  }
  
  closeSearch() {
    this.searchDrawer.classList.remove('is-open');
  }
}

class MobileMenu {
  constructor() {
    this.menuToggle = document.querySelector('.header__menu-toggle');
    this.mobileMenu = document.querySelector('.header__mobile-menu');
    this.mobileMenuOverlay = document.querySelector('.header__mobile-menu-overlay');
    this.menuClose = document.querySelector('.mobile-menu__close');
    
    console.log('MobileMenu elements found:', {
      menuToggle: !!this.menuToggle,
      mobileMenu: !!this.mobileMenu,
      mobileMenuOverlay: !!this.mobileMenuOverlay,
      menuClose: !!this.menuClose
    });
    
    if (this.menuToggle && this.mobileMenu) {
      this.init();
    }
  }
  
  init() {
    this.menuToggle.addEventListener('click', () => {
      this.openMenu();
    });
    
    // Close button
    if (this.menuClose) {
      this.menuClose.addEventListener('click', () => {
        this.closeMenu();
      });
    }
    
    // Close on overlay click
    if (this.mobileMenuOverlay) {
      this.mobileMenuOverlay.addEventListener('click', () => {
        this.closeMenu();
      });
    }
  }
  
  openMenu() {
    console.log('Opening mobile menu...');
    console.log('Mobile menu classes before:', this.mobileMenu.className);
    
    this.mobileMenu.classList.add('is-open');
    if (this.mobileMenuOverlay) {
      this.mobileMenuOverlay.classList.add('is-open');
    }
    document.body.classList.add('menu-open');
    
    console.log('Mobile menu classes after:', this.mobileMenu.className);
    console.log('Mobile menu computed style:', {
      transform: window.getComputedStyle(this.mobileMenu).transform,
      visibility: window.getComputedStyle(this.mobileMenu).visibility,
      display: window.getComputedStyle(this.mobileMenu).display,
      zIndex: window.getComputedStyle(this.mobileMenu).zIndex
    });
  }
  
  closeMenu() {
    this.mobileMenu.classList.remove('is-open');
    if (this.mobileMenuOverlay) {
      this.mobileMenuOverlay.classList.remove('is-open');
    }
    document.body.classList.remove('menu-open');
  }
}

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});

// Lazy loading images
if ('IntersectionObserver' in window) {
  const imageObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        img.src = img.dataset.src;
        img.classList.add('is-loaded');
        imageObserver.unobserve(img);
      }
    });
  });
  
  document.querySelectorAll('img[data-src]').forEach(img => {
    imageObserver.observe(img);
  });
}

// Initialize all modules when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new ThemeCart();
  new ProductVariants();
  new ThemeSearch();
  new MobileMenu();
  
  // Initialize AOS animations
  if (typeof AOS !== 'undefined') {
    AOS.init({
      duration: 800,
      easing: 'ease-out-cubic',
      once: true,
      offset: 50,
      disable: false,
      anchorPlacement: 'top-bottom'
    });
  }
  
  // Remove AOS from product cards to prevent visibility issues
  const productCards = document.querySelectorAll('.product-card');
  productCards.forEach((card) => {
    card.removeAttribute('data-aos');
    card.removeAttribute('data-aos-delay');
  });
  
  // Initialize any other theme functionality
  console.log('Theme initialized');
});